import { Wallet } from 'lucide-react'
import type { PaymentMethodConfig, WalletProvider } from '@/types/payment'
import { isEvmNetwork, isSolanaNetwork } from '@/lib/payment-chains'

export const PAYMENT_GATEWAY_METHOD: PaymentMethodConfig = {
	id: 'payment-gateway',
	label: 'Payment Gateway',
	provider: 'nowpayments',
	icon: Wallet,
	isEnabled: (currency) => Boolean(currency.nowpayments_code) && currency.can_deposit,
}

export const WALLET_PAYMENT_METHODS: Partial<Record<WalletProvider, PaymentMethodConfig>> = {
	metamask: {
		id: 'metamask',
		label: 'MetaMask',
		provider: 'metamask',
		iconUrl: 'https://cdn.jsdelivr.net/gh/glincker/thesvg@main/public/icons/metamask/default.svg',
		isEnabled: (currency) => currency.can_deposit && isEvmNetwork(currency.network),
	},
	phantom: {
		id: 'phantom',
		label: 'Phantom',
		provider: 'phantom',
		iconUrl:
			'https://mintcdn.com/phantom-e50e2e68/tU9g5MXFXgx4l6Em/resources/images/Phantom_SVG_Icon.svg?fit=max&auto=format&n=tU9g5MXFXgx4l6Em&q=85&s=7170eec10d9199f7766d6e4ccd1e56ff',
		isEnabled: (currency) => currency.can_deposit && isSolanaNetwork(currency.network),
	},
}

export const ALL_PAYMENT_METHODS: PaymentMethodConfig[] = [
	PAYMENT_GATEWAY_METHOD,
	...Object.values(WALLET_PAYMENT_METHODS).filter((method): method is PaymentMethodConfig => Boolean(method)),
]
